<div class="d-flex flex-row row">
  <div class="col-5">
    <!--Proposal-->
    <button [matMenuTriggerFor]="proposalMenu" mat-raised-button color="primary" class="ml-2 mt-2"
            *ngIf="case?.product?.group_slug === 'unified' || case?.product?.group_slug === 'dmp' || case?.product?.group_slug === 'ds'"
            [disabled]="!isElementRestricted()">
      {{ 'CASES.single.draft.proposal.label' | translate }}
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
    <mat-menu #proposalMenu="matMenu">
      <button mat-menu-item color="primary" class="mb-1 mr-md-4"
              (click)="generateProposal()"
              [disabled]="!isElementRestricted()">
        {{ "CASES.details.generate-proposal" | translate }}
      </button>
      <button mat-menu-item
              (click)="sendProposalToCreditors(case.id)"
              [disabled]="!allCreditorsHaveProposalEmails || !isElementRestricted()">
        {{ 'CASES.single.draft.proposal.send_to_creditors' | translate }}
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="sendProposalToClient()"
              [disabled]="!isElementRestricted() || disableProposalButtons || case?.product?.group_slug !== 'ds'">
        {{ 'CASES.single.draft.proposal.send_and_adjust' | translate }}
      </button>
      <button mat-menu-item (click)="previewProposal('client')"
              [disabled]="!isElementRestricted()">
        {{ 'CASES.single.draft.proposal.preview_client' | translate }}
      </button>
      <button mat-menu-item (click)="previewProposal('partner')" *ngIf="case?.joint_application"
              [disabled]="!isElementRestricted()">
        {{ 'CASES.single.draft.proposal.preview_partner' | translate }}
      </button>
      <button mat-menu-item (click)="requestProposalSignature()"
              [disabled]="!isElementRestricted() || disableProposalButtons || true">
        {{ 'CASES.single.draft.proposal.request_signature.label' | translate }}
      </button>
    </mat-menu>
    <!-- Get latest dm propuesta -->
    <a mat-raised-button color="primary" class="ml-2" [disabled]="!latestPropuestaPdfLocation" target="_blank"
       href="{{storageUrl + latestPropuestaPdfLocation}}"
       [title]="!latestPropuestaPdfLocation ?
        ('CASES.single.get-propuesta-button-disabled' | translate) :
         ('CASES.single.get-propuesta' | translate)">
      {{ "CASES.single.get-propuesta" | translate }}
    </a>
    <!-- Get latest client propuesta -->
    <a mat-raised-button color="primary" class="ml-2" [disabled]="!latestPropuestaClientPdfLocation" target="_blank"
       href="{{storageUrl + latestPropuestaClientPdfLocation}}"
       [title]="!latestPropuestaClientPdfLocation ?
        ('CASES.single.get-propuesta-button-disabled' | translate) :
         ('CASES.single.get-client-proposal' | translate)">
      {{ "CASES.single.get-client-proposal" | translate }}
    </a>
    <!-- Refer case-->
    <div style="display: inline-block;margin-left:0.5em;" *ngIf="case && authUser?.packager?.master">
      <button mat-raised-button [mat-menu-trigger-for]="referCaseMenu" color="primary"
              [disabled]="!isElementRestricted()">
        {{ 'CASE_CREDITOR.refer_case.heading' | translate }}
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #referCaseMenu class="refer-case-menu">
        <button mat-menu-item
                color="primary" [disabled]="!!case.epi_ref_number" (click)="sendCase(case, 'epi')">
          <span
            *ngIf="!case.epi_ref_number">{{ 'CASE_CREDITOR.refer_case.referral_to_epi.refer_case_to_epi' | translate }}</span>
          <span
            *ngIf="case.epi_ref_number">{{ 'CASE_CREDITOR.refer_case.referral_to_epi.referred_to' | translate }} {{ case.epi_ref_number }}</span>
        </button>

        <button mat-menu-item
                color="primary" [disabled]="!!case.deu_ref_number" (click)="sendCase(case, 'deu')">
          <span
            *ngIf="!case.deu_ref_number">{{ 'CASE_CREDITOR.refer_case.referral_to_deu.refer_case_to_deu' | translate }}</span>
          <span
            *ngIf="case.deu_ref_number">{{ 'CASE_CREDITOR.refer_case.referral_to_deu.referred_to' | translate }} {{ case.deu_ref_number }}</span>
        </button>
      </mat-menu>
    </div>
  </div>

  <div class="col-7 text-right">
    <div class="mt-2 ml-2 d-flex flex-column align-items-center amount-box-fund">
      <p class="text-center mb-1">{{ 'CASE_CREDITOR.model.active_debt' | translate }}</p>
      <p class="m-0">{{ totalActiveDebt ?? 0 | currency }}</p>
    </div>
    <div class="mt-2 ml-2 d-flex flex-column align-items-center amount-box-fund">
      <p class="text-center mb-1">{{ 'CASES.settlement_balance' | translate }}</p>
      <p class="m-0">{{ settlementBalance ?? 0 | currency }}</p>
    </div>
    <div class="mt-2 ml-2 d-flex flex-column align-items-center amount-box-fund">
      <p class="text-center mb-1">{{ 'CASES.debts_settled' | translate }}</p>
      <p class="m-0">{{ debtsSettledAmount ?? 0 | currency }}</p>
    </div>
    <div class="mt-2 d-flex flex-column align-items-center amount-box-item">
      <p class="text-center mb-1">{{ 'CASES.settlement_received' | translate }}</p>
      <p class="m-0">{{ totalContribution ?? 0 | currency }}</p>
    </div>
  </div>
  <div *ngIf="authUser?.id === 1 || isLocalOrStagingEnvironment" class="col-7 offset-5 text-right mt-3">
    <div class="col d-flex flex-row justify-content-end text-right">
      <div>
        <p>sum_total_debt_amount: {{ case.sum_total_debt_amount | number:'1.2-2' }}</p>
        <p>sum_total_negotiated_amount: {{ case.sum_total_negotiated_amount | number:'1.2-2' }}</p>
        <p>sum_total_reduction: {{ case.sum_total_reduction | number:'1.2-2' }}</p>
        <p>debt_reduction: {{ case.debt_reduction | number:'1.2-2' }}</p>
        <p>Is above 50%: {{ case?.is_above50_percent }}</p>
      </div>
      <div class="ml-3">
        <p>microlenders: {{ case.microlenders }}</p>
        <p>settlement_paid: {{ case.settlement_paid | number:'1.2-2' }}</p>
        <p>settlement_fees: {{ case.settlement_fees | number:'1.2-2' }}</p>
        <p>settlement_received: {{ case.settlement_received | number:'1.2-2' }}</p>
        <p>settlement_balance: {{ case.settlement_balance | number:'1.2-2' }}</p>
      </div>
    </div>
  </div>
</div>

<!--Loan creditors-->
<div class="loan-creditors-section" *ngIf="useCreditorLoanFields">
  <h3>{{ "CASES.editor.creditors.heading" | translate }}</h3>
  <button mat-raised-button color="primary" [matMenuTriggerFor]="menuUnsecured" [disabled]="!isElementRestricted()">
    {{ "SHARED.bulk-actions" | translate }}
  </button>
  <mat-menu #menuUnsecured="matMenu">
    <button mat-menu-item [disabled]="selectionLoanCreditors.selected.length === 0"
            (click)="changeStatus($event, selectionLoanCreditors, 'unsecured_creditors')">
      {{ 'CASES.list.bulk_actions.change_creditor_status_product' | translate }}
    </button>
    <!-- Send extrajudicial claim -->
    <div
      [title]="!selectionLoanCreditors.selected.length ? ('CASES.single.creditors.actions.action_not_available' | translate) : ''">
      <button mat-menu-item
              [disabled]="!selectionLoanCreditors.selected.length || !canSendExtrajudicial.includes(authUser.id)"
              (click)="sendExtrajudicialClaim(selectionLoanCreditors)">
        {{ 'SHARED.send' | translate }} {{ 'CASES.single.creditors.actions.extrajudicial_claim' | translate }}
      </button>
    </div>
  </mat-menu>
  <div *ngIf="case" class="mat-elevation-z8"
       style="border: 1px solid rgba(0, 0, 0, 0.12); border-top: none; margin-bottom: 50px">
    <table style="width: 100%; display: table;overflow-x: auto;" mat-table matSort [dataSource]="loanCreditors"
           [ngClass]="'table-responsive'">
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="p-r-10">
          <mat-checkbox (change)="$event ? masterToggle(selectionLoanCreditors, loanCreditors) : null" color="primary"
                        [checked]="selectionLoanCreditors.hasValue() && isAllSelected(selectionLoanCreditors, loanCreditors)"
                        [indeterminate]="selectionLoanCreditors.hasValue() && !isAllSelected(selectionLoanCreditors, loanCreditors)">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()" color="primary"
                        (change)="$event ? selectionLoanCreditors.toggle(row) : null"
                        [checked]="selectionLoanCreditors.isSelected(row)">
          </mat-checkbox>
        </td>
        <td mat-footer-cell *matFooterCellDef><b>Total</b></td>
      </ng-container>
      <!-- Ref Number -->
      <ng-container matColumnDef="ref_number">
        <th mat-header-cell *matHeaderCellDef>{{ "CASE_CREDITOR.model.reference_number" | translate }}</th>
        <td mat-cell *matCellDef="let element; let i =  index" [ngStyle]="{'background-color': returnLenderType(element.lender_type)}">
          <a class="pr-3" [routerLink]="['/cases', element.case?.id, 'creditors', element.id, 'general']">{{ element.reference_number }}</a>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <form *ngIf="loanCreditorsForm" [formGroup]="loanCreditorsForm">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>{{ "CASES.single.creditor-name" | translate }}</th>
          <td mat-cell *matCellDef="let element; let i =  index"
              [ngStyle]="{'background-color': returnLenderType(element.lender_type)}">
            <app-input type="select" formControlName="creditor_id" appearance="outline"
                       *ngIf="isEditing && currentRow === i"
                       [label]="'CASES.single.general.status_editor.product' | translate"
                       [selectOptions]="allCreditors" [selectLabel]="['name']" [selectValue]="'id'" class="full-width"
                       [showClear]="false" [fullWidth]="false" [showLabel]="false" [searchable]="true">
            </app-input>
            <span *ngIf="!isEditing || currentRow != i">
                {{ getUnsecuredCreditorName(element.creditor_id) }}
              <span *ngIf="element.current_creditor_id">
                  <!-- mat info icon -->
                  <mat-icon style="height: 18px; width: 18px; font-size: 16px; color: #04abe4 !important;"
                            (click)="showInfo(element)">info</mat-icon>
                </span>
              </span>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="current_name">
          <th mat-header-cell *matHeaderCellDef>{{ "CASE_CREDITOR.model.relations.current_creditor" | translate }}</th>
          <td mat-cell *matCellDef="let element; let i =  index"
              [ngStyle]="{'background-color': returnLenderType(element.creditor.lender_type)}">
            <app-input type="select" formControlName="current_creditor_id" appearance="outline"
                       *ngIf="isEditing && currentRow === i"
                       [label]="'CASES.single.general.status_editor.product' | translate"
                       [selectOptions]="allCreditors" [selectLabel]="['name']" [selectValue]="'id'" class="full-width"
                       [showClear]="true" [fullWidth]="false" [showLabel]="false" [searchable]="true">
            </app-input>
            <p *ngIf="!isEditing || currentRow != i">{{ getUnsecuredCreditorName(element.current_creditor_id) }}</p>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="loan_id">
          <th mat-header-cell *matHeaderCellDef>{{ "CASE_CREDITOR.model.loan_id" | translate }}</th>
          <td mat-cell *matCellDef="let element; let i =  index"
              [ngStyle]="{'background-color': returnLenderType(element.creditor.lender_type)}">
            <app-input *ngIf="isEditing && currentRow === i" type="text" formControlName="loan_id"
                       appearance="outline" fullWidth="false"
                       [label]="'Loan ID'">
            </app-input>
            <span *ngIf="!isEditing || currentRow != i">{{ element.loan_id }}</span>
          </td>
          <td mat-footer-cell *matFooterCellDef class="ms-1"></td>
        </ng-container>

        <ng-container matColumnDef="initial_balance">
          <th mat-header-cell *matHeaderCellDef>{{ "CASE_CREDITOR.model.confirmed_debt" | translate }}</th>
          <td mat-cell *matCellDef="let element; let i =  index"
              [ngStyle]="{'background-color': returnLenderType(element.creditor.lender_type)}">
            <app-input *ngIf="isEditing && currentRow === i" type="text" formControlName="initial_balance"
                       appearance="outline" fullWidth="false"
                       [label]="'Client Debt Amount'">
            </app-input>
            <span *ngIf="!isEditing || currentRow != i">{{ element.initial_balance | number: '1.2-2' }}</span>
          </td>
          <td mat-footer-cell *matFooterCellDef class="ms-1">{{ getTotal('initial_balance')  | number: '1.2-2' }} €</td>
        </ng-container>

        <ng-container matColumnDef="last_paid">
          <th mat-header-cell *matHeaderCellDef>Last Paid</th>
          <td mat-cell *matCellDef="let element; let i =  index"
              [ngStyle]="{'background-color': returnLenderType(element.creditor.lender_type)}">
            <mat-form-field color="primary" *ngIf="isEditing && currentRow === i">
              <mat-label>{{ "CASES.details.last-paid" | translate }}</mat-label>
              <input matInput [matDatepicker]="lastPaidDate" formControlName="last_paid">
              <mat-datepicker-toggle matSuffix [for]="lastPaidDate"></mat-datepicker-toggle>
              <mat-datepicker #lastPaidDate color="primary"></mat-datepicker>
            </mat-form-field>
            <span *ngIf="!isEditing || currentRow != i">{{ element.last_paid | toDateObject | date:'dd/MM/yy' }}</span>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="product">
          <th mat-header-cell *matHeaderCellDef
              class="p-r-10">{{ "ADDRESS-BOOK.product_type" | translate }}
          </th>
          <td mat-cell *matCellDef="let element; let i =  index"
              [ngStyle]="{'background-color': returnLenderType(element.creditor.lender_type)}">
            <app-input type="select" formControlName="product_id" appearance="outline"
                       *ngIf="isEditing && currentRow === i"
                       [label]="'CASES.single.general.status_editor.product' | translate"
                       [selectOptions]="products" [selectLabel]="['name']" [selectValue]="'id'" class="full-width"
                       [showClear]="false" [fullWidth]="false" [showLabel]="false" [searchable]="true">
            </app-input>
            <span *ngIf="!isEditing || currentRow != i">{{ getProductName(element.product_id) }}</span>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="debt_amount">
          <th mat-header-cell *matHeaderCellDef>{{ "CASE_CREDITOR.model.debt_amount" | translate }}</th>
          <td mat-cell *matCellDef="let element; let i =  index"
              [ngStyle]="{'background-color': returnLenderType(element.creditor.lender_type)}">
            <app-input *ngIf="isEditing && currentRow === i" type="text" formControlName="debt_amount"
                       appearance="outline" fullWidth="false"
                       [label]="'Debt Amount'">
            </app-input>
            <span *ngIf="!isEditing || currentRow != i">{{ element.debt_amount | number: '1.2-2' }}€</span>
          </td>
          <td mat-footer-cell *matFooterCellDef class="ms-1"> {{ getTotal('debt_amount')  | number: '1.2-2' }} €</td>
        </ng-container>

        <ng-container matColumnDef="negotiated_amount">
          <th mat-header-cell *matHeaderCellDef>{{ "CASE_CREDITOR.model.negotiated_amount" | translate }}</th>
          <td mat-cell *matCellDef="let element; let i = index"
              [ngStyle]="{'background-color': returnLenderType(element.creditor.lender_type)}">
            <app-input *ngIf="isEditing && currentRow === i" type="text" formControlName="negotiated_amount"
                       appearance="outline" fullWidth="false"
                       [label]="'Negotiated Amount'">
            </app-input>
            <span *ngIf="!isEditing || currentRow != i">{{ element.negotiated_amount | number: '1.2-2' }} <span
              *ngIf="element.negotiated_amount">€</span></span>
          </td>
          <td mat-footer-cell *matFooterCellDef> {{ getTotal('negotiated_amount')  | number: '1.2-2' }} €</td>
        </ng-container>

        <ng-container matColumnDef="active_debt">
          <th mat-header-cell *matHeaderCellDef>{{ "CASE_CREDITOR.model.active_debt" | translate }}</th>
          <td mat-cell *matCellDef="let element">
            {{ element.active_debt | currency:'EUR' }}
          </td>
          <td mat-footer-cell *matFooterCellDef>
            {{ getTotal('active_debt') | currency:'EUR' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="total_reduction">
          <th mat-header-cell *matHeaderCellDef>{{ "CASE_CREDITOR.model.total_reduction" | translate }} %</th>
          <td mat-cell *matCellDef="let element; let i = index"
              [ngStyle]="{'background-color': returnLenderType(element.creditor.lender_type)}">
            <span
              *ngIf="(element.pivot.debt_amount > 0) && (element.negotiated_amount > 0)">{{ (element.debt_amount - element.negotiated_amount) | number: '1.2-2' }}
              €</span>
          </td>
          <td mat-footer-cell *matFooterCellDef> {{ getTotal('total_reduction')  | number: '1.2-2' }} €</td>
        </ng-container>

        <ng-container matColumnDef="percent_reduction">
          <th mat-header-cell *matHeaderCellDef>{{ "CASE_CREDITOR.model.reduction" | translate }}</th>
          <td mat-cell *matCellDef="let element; let i = index"
              [ngStyle]="{'background-color': returnLenderType(element.creditor.lender_type)}">
            <span *ngIf="(element.initial_balance > 0) && (element.negotiated_amount > 0)">{{
                +(+(+(element.initial_balance - element.negotiated_amount) / element.initial_balance) *
                  100) | number: '1.2-2'
              }} <span *ngIf="(element.initial_balance > 0) && (element.negotiated_amount > 0)">%</span></span>
          </td>
          <td mat-footer-cell *matFooterCellDef><span>{{ getTotal('percent_reduction')  | number: '1.2-2' }} %</span>
          </td>
        </ng-container>

        <!-- percentage accepted -->
        <ng-container matColumnDef="percent_accepted">
          <th mat-header-cell *matHeaderCellDef>{{ "CASE_CREDITOR.model.percent_accepted" | translate }}</th>
          <td mat-cell *matCellDef="let element; let i = index"
              [ngStyle]="{'background-color': returnLenderType(element.creditor.lender_type)}">
              <span
                *ngIf="(element.case_reditor_status?.slug === 'dm_accepted' || element.case_reditor_status?.slug === 'dm_signed')">
                {{ getDebtPercentage(element) | number: '1.2-2' }} <span *ngIf="getDebtPercentage(element)">%</span>
              </span>
          </td>
          <td mat-footer-cell
              *matFooterCellDef="let element; let i = index">{{ getResponseReceivedStatus(loanCreditors.data) }}%
          </td>
        </ng-container>

        <ng-container matColumnDef="amount_updated_at">
          <th mat-header-cell *matHeaderCellDef>{{ "CASE_CREDITOR.model.amount_updated_at" | translate }}</th>
          <td mat-cell *matCellDef="let element; let i =  index"
              [ngStyle]="{'background-color': returnLenderType(element.creditor.lender_type)}">
            <mat-form-field color="primary" *ngIf="isEditing && currentRow === i">
              <mat-label>{{ "CASE_CREDITOR.model.amount_updated_at" | translate }}</mat-label>
              <input matInput [matDatepicker]="amountUpdatedAt" formControlName="amount_updated_at">
              <mat-datepicker-toggle matSuffix [for]="amountUpdatedAt"></mat-datepicker-toggle>
              <mat-datepicker #amountUpdatedAt color="primary"></mat-datepicker>
            </mat-form-field>
            <span
              *ngIf="!isEditing || currentRow != i">{{ element.amount_updated_at | toDateObject | date:'dd/MM/yy' }}</span>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
      </form>

      <ng-container matColumnDef="creditor_lender_type">
        <th mat-header-cell *matHeaderCellDef>{{ "CASE_CREDITOR.model.response_received.label" | translate }}</th>
        <td mat-cell *matCellDef="let element; let i = index"
            [ngStyle]="{'background-color': returnLenderType(element.creditor.lender_type)}">
          <span>{{ getTranslatedCaseCreditorStatus(element) }}</span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <ng-container matColumnDef="days_in_status">
        <th mat-header-cell *matHeaderCellDef>{{ "CASE_CREDITOR.days_in_status" | translate }}</th>
        <td mat-cell *matCellDef="let element; let i = index"
            [ngStyle]="{'background-color': returnLenderType(element.creditor.lender_type)}">
          <span>{{ getDaysInStatus(element) }}</span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>{{ "SHARED.actions" | translate }}</th>
        <td mat-cell *matCellDef="let element; let i = index"
            [ngStyle]="{'background-color': returnLenderType(element.creditor.lender_type)}">

          <button mat-icon-button class="ml-1" [matMenuTriggerFor]="menu" style="color: 0a2540;"
                  [disabled]="!isElementRestricted()">
            <mat-icon class="pr-1" style=" vertical-align: baseline !important; color: 0a2540;">
              settings
            </mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item *ngIf="element.case_reditor_status?.slug !== 'ds_settlement_requested'"
                    [disabled]="element.case_reditor_status?.slug === 'ds_settled'"
                    (click)="requestDebtSettlement(element, case)">
              {{ "CREDITORS.debt-settlement-request.title" | translate }}
            </button>
            <button mat-menu-item *ngIf="element.case_reditor_status?.slug === 'ds_settlement_requested'"
                    (click)="requestDebtSettlement(element, case)">
              View Debt Settlement Request
            </button>
            <button mat-menu-item
                    (click)="openPaymentPlanGenerationModal(element)">
              {{ "CASES.single.payments.actions.create_additional_payment_plan" | translate }}
            </button>
            <button *ngIf="!element.verified" mat-menu-item [disabled]="case.contracts.length === 0"
                    (click)="verifyCreditor($event, [element.id], 'unsecured_creditors', case)">
              {{ "CASES.details.verify-send-mandates" | translate }}
            </button>
            <button *ngIf="element.verified" mat-menu-item
                    (click)="verifyCreditor($event, [element.id], 'unsecured_creditors', case)">
              {{ "CASES.details.resend-mandates" | translate }}
            </button>
            <button *ngIf="element.recovery_creditor_id" mat-menu-item
                    (click)="sendMandatesRecoveryAgent($event, [element.id])">
              {{ "CASES.details.send-mandates-recovery" | translate }}
            </button>
            <button mat-menu-item
                    (click)="sendProposalAndAccord([element.id])">
              {{ "CASES.details.send-proposal-accord" | translate }}
            </button>
          </mat-menu>
          <button mat-icon-button class="ml-21 edit-button" [id]="i" (click)="toggleLoanEditMode(i, element)"
                  style="color: 0a2540;" [disabled]="!isElementRestricted()">
            <mat-icon class="pr-1" style=" vertical-align: baseline !important; color: 0a2540;">
              {{ !isEditing || currentRow != i ? 'edit' : 'save' }}
            </mat-icon>
          </button>
          <mat-icon class="pr-1" style="color: #0a2540;" (click)="creditorDetails(element, $event)">info</mat-icon>
          <mat-icon class="ml-2" style="color: #0a2540;" (click)="openCalculationModal(element, $event)">euro_symbol
          </mat-icon>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="loader">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element" style="min-width: 20px; padding: 0px"
            [ngStyle]="{'background-color': returnLenderType(element.creditor.lender_type)}">
          <mat-spinner *ngIf="isLoading && isLoadingIds.length && isLoadingIds.indexOf(element.id) !== -1"
                       diameter="20" color="accent"></mat-spinner>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsLoanCreditors"></tr>
      <tr mat-row *matRowDef="let element; columns: displayedColumnsLoanCreditors;" [class.row-is-bold]="element.can_settle"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumnsLoanCreditors"></tr>
    </table>
    <div class="row mt-3" *ngIf="!allCreditorsHaveProposalEmails">
      <div class="alert alert-danger ml-4" role="alert">
        <h4 class="alert-heading">{{ "CASES.single.draft.creditor-prop-email-not-set" | translate }}</h4>
        <p>{{ "CASES.single.draft.creditor-prop-email-not-set-action" | translate }}</p>
        <hr>
        <div>
          <table class="table table-striped">
            <thead>
            <tr>
              <th>{{ "CASES.single.creditor-name" | translate }}</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let creditor of creditorWithoutProposalEmails">
              <td><a href="creditor/{{creditor.id}}/edit" target="_blank">{{ creditor.name }}</a></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div *ngIf="isFetching" class="text-center" style="padding: 50px">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div *ngIf="!isFetching && loanCreditors && !loanCreditors.data.length" style="padding: 50px">
      <h3 class="text-center">{{ "PAYMENTS.no-record" | translate }}</h3>
    </div>
  </div>
</div>
